export default "__VITE_ASSET__DOH184VM__"